import { createSlice } from '@reduxjs/toolkit';
import utils from "../../utils.js"
import useBus from '../../useBus.js';
import { useEffect } from 'react';
import { stat } from 'fs-extra';

const initialState = {
  decoder: "mse",
  screnObjList:[ 
  ],
  type: "box",
  resizeWidth: "",
  openLimit: true,
  playItv: null,
  alertTimeTip: 5,//五分钟弹出提醒框，六分钟不继续就关闭播放
  showAlert: false,
  styleList: [],
  currentChoiceId: null,
  data: null, 
  viewType: "ws",
  currentStreamType: 0,  //0主码流，1子码流
  videoIsAllScreen: false, // 是否全屏  
  rootContainer: null,
};

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    add: (state) => {
      state.screnObjList.push({id: utils.randomStr(8),hadUsed: false,isDevice:true,realPlay:true});
    },
    setContainer: (state, data) => {
      const { payload } = data
      state.rootContainer = payload
    },
    changeVideoAllScreen: (state, data) => {
      const { payload } = data
      state.videoIsAllScreen = payload
    }, 
    initWinNum: (state, data) => {
     const { payload } = data

     let temp = []
     for(let i=0; i<payload; i++){
        temp.push({id: utils.randomStr(8),hadUsed: false,isDevice:true,realPlay:true},)
     }

     state.screnObjList = temp
    },
    setScreenObjList: (state, data) => {//分屏----共用
      console.log(data)
      state.screnObjList = data.payload
    },
    updateScreenObj: (state, data) => {
      const { payload } = data
      const {index} =  payload
      delete payload.index
      state.screnObjList[index] = {
        ...state.screnObjList[index], 
        ...payload
      }
    },
    replaceScreenObj: (state, params) => {
      console.log("replaceScreenObj")
      const {index, data}  = params.payload
      // const { payload } = data
      // const {index} =  payload
      // delete payload.index
      state.screnObjList[index] = data
    },
    setViewType: (state, data) => {
      state.viewType = data.payload
    },
    setCurrentChoiceId: (state, data) => {
      state.currentChoiceId = data.payload
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    
  },
});


export const selectScreenObjList = state => state.layout.screnObjList

export const selectViewType = state => state.layout.viewType

export const selectCurrentChoiceId = state => state.layout.currentChoiceId

export default layoutSlice.reducer;

export const { setScreenObjList, updateScreenObj, replaceScreenObj, initWinNum, changeVideoAllScreen, setContainer, setCurrentChoiceId}  =  layoutSlice.actions
